import React, { useState, useEffect } from 'react';
import { TextField, InputAdornment, IconButton, Button, CircularProgress } from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import AccountCircle from '@mui/icons-material/AccountCircle';
import Email from '@mui/icons-material/Email';
import SmartphoneIcon from '@mui/icons-material/Smartphone';
import Lock from '@mui/icons-material/Lock';
import { toast, Zoom } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import awlogo from "../Assets/images/Group 16808.png";
import axios from 'axios';
import OTPInput from 'react-otp-input'
import axiosInstance from '../Axios/AxiosConfig';
import { setTokens, saveUserDetails, isTokenExpired } from './AuthUtil';
import { Auth_URL } from '../Axios/config';
import { profileModel } from '../Axios/AxiosConfig';
import { useLocation } from 'react-router-dom';
import { Loader } from 'lucide-react';
import Cookies from 'universal-cookie';

const cookies = new Cookies();

function SignUp() {
    const [showPassword, setShowPassword] = useState(false);
    const [showCPassword, setShowCPassword] = useState(false);
    const [name, setName] = useState('');
    const [error, setError] = useState('');
    const [user, setUser] = useState('');
    const [password, setPassword] = useState('');
    const [cpassword, setcPassword] = useState('');
    const [emailLoading, setEmailLoading] = useState(false);
    const [phoneLoading, setPhoneLoading] = useState(false);
    const [errors, setErrors] = useState({});
    const location = useLocation();
    const [SignupMethod, setSignUpMethod] = useState('Email');
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [timer, setTimer] = useState(0);
    const [isWaiting, setIsWaiting] = useState(false);
    const [otp, setOtp] = useState('');
    const [link, setlink] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        const token = cookies.get('accessToken');
        if (token && !isTokenExpired(token)) {
            const { state } = location;
            navigate(state?.from || '/', { replace: true });
        }
    }, [navigate, location]);

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const id = queryParams.get('Link') || '';
        setlink(id)
    }, [location]);

    const handleClickShowPassword = () => setShowPassword((show) => !show);

    const handleClickShowCPassword = () => setShowCPassword((show) => !show);

    const validate = () => {
        let tempErrors = {};

        tempErrors.emailOrPhone = SignupMethod === 'Email'
            ? /^\S+@\S+\.\S+$/.test(user) ? '' : 'Please enter a valid email address.'
            : /^[0-9]{10}$/.test(user) ? '' : 'Please enter a valid phone number.';

        tempErrors.password = password.length > 7 ? '' : 'Password must be at least 8 characters long.';

        tempErrors.cpassword = cpassword === password
            ? ''
            : 'Password does not match.';

        setErrors(tempErrors);

        return Object.values(tempErrors).every(x => x === '');
    };

    const handleSubmit = () => {
        if (validate()) {
            handleSignup();
        } else {
            console.log('Form is invalid');
        }
    };

    const validateInput = () => {
        if (otp.length === 6) {
            return true
        }
        else {
            setError('Invalid input. Please enter a valid 6 digit OTP');
        }
    }

    // const handleSignup = async () => {
    //     try {
    //         let res;

    //         if (SignupMethod === 'Email') {
    //             res = await axios.post(`${Auth_URL}Signup`, {
    //                 email: user,
    //                 user: user,
    //                 password
    //             });
    //         }

    //         else {
    //             res = await axios.post(`${Auth_URL}SignupWithPhone`, {
    //                 phone: `+91${user}`,
    //                 password
    //             });
    //         }

    //         if (res.status === 200) {
    //             setIsModalVisible(true);
    //         }

    //     } catch (err) {
    //         if (err.response?.status === 500) {
    //             toast.error(err?.response?.data?.error, {
    //                 position: 'top-center',
    //                 limit: 1,
    //                 transition: Zoom,
    //                 autoClose: 2000,
    //                 hideProgressBar: false,
    //                 closeOnClick: false,
    //                 pauseOnHover: true,
    //                 draggable: true,
    //                 progress: undefined,
    //                 theme: 'dark'
    //             });

    //             setIsModalVisible(true);
    //         }
    //     }
    // };

    const [loading, setLoading] = useState(false);

    const handleSignup = async () => {
        if (loading) return;

        try {
            setLoading(true);
            let res;

            if (SignupMethod === 'Email') {
                res = await axios.post(`${Auth_URL}Signup`, {
                    email: user,
                    user: user,
                    password
                });
            } else {
                res = await axios.post(`${Auth_URL}SignupWithPhone`, {
                    phone: `+91${user}`,
                    password
                });
            }

            if (res.status === 200) {
                setIsModalVisible(true);
            }

        } catch (err) {
            if (err.response?.status === 500 && err.response?.data?.error === "User Account not verified") {
                toast.error(err?.response?.data?.error, {
                    position: 'top-center',
                    limit: 1,
                    transition: Zoom,
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: false,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: 'dark'
                });
                setIsModalVisible(true);
            }

            if (err.response.status === 500 &&
                err.response.data.error.includes("already exists")) {
                toast.error(err?.response?.data?.error, {
                    position: 'top-center',
                    limit: 1,
                    transition: Zoom,
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: false,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: 'dark'
                });
            }

        } finally {
            setLoading(false);
        }
    };

    const handleVerify = async () => {
        try {
            let res = await axios.post(`${Auth_URL}VerfiyAccount`, {
                user: SignupMethod === 'Email' ? user : `+91${user}`,
                code: otp,
                password
            });

            if (res.status == 200) {
                handleLogin()
                setIsModalVisible(false)
            }
        }

        catch (err) {
            if (err.response.status === 500) {
                setError(err?.response?.data?.error)
                console.log(err?.response?.data)
            }
        }
    }

    const handleResend = async () => {
        try {

            let res = await axios.post(`${Auth_URL}Resend-Confirmation-code`, {
                user: SignupMethod === 'Email' ? user : `+91${user}`,
            });

            if (res.status == 200) {
                setIsWaiting(true);
                setTimer(30);
                setOtp('')
                setError('')
            }
        }
        catch (err) {
            if (err.response.status === 500) {
                setError(err?.response?.data?.error)
                console.log(err?.response?.data)
            }
        }
    }

    const handleLogin = async () => {
        try {
            let res = await axios.post(`${Auth_URL}Signin`, {
                email: SignupMethod === 'Email' ? user : `+91${user}`,
                password: password
            });

            if (res.status == 200) {
                const { accessToken, refreshToken, id } = res.data;
                setTokens(accessToken, refreshToken);

                const firstname = name.split(' ')[0];
                const lastname = name.split(' ')[1];
                const email = SignupMethod === 'Email' ? user : "";
                const mobile = SignupMethod === 'Email' ? '' : `+91${user}`;

                saveUserDetails(firstname, lastname, email, mobile, id);

                const selectedSymptoms = JSON?.parse(localStorage?.getItem('SelectedSymptoms')) || []

                const selectedWellness = JSON?.parse(localStorage?.getItem('SelectedWellness')) || []

                let ExploreApp = localStorage.getItem('ExploreApp');
                ExploreApp = ExploreApp ? JSON.parse(ExploreApp) : { selected: false };

                const { state } = location;

                if (state?.from) {
                    navigate(state.from, { replace: true });
                }

                else {

                    if (selectedWellness.length > 0) {
                        await profileModel.post('/AddwellnessCategories', {
                            UID: id,
                            Categories: selectedWellness
                        })
                    }

                    if (selectedSymptoms.length > 0) {
                        await profileModel.post('/UpdateVikriti', {
                            UID: id,
                            ...selectedSymptoms
                        })
                    }

                    if (ExploreApp?.selected) {
                        localStorage.removeItem('ExploreApp')
                        navigate('/profile', { replace: true })
                    }

                    else {
                        navigate('/packagecheckout', { replace: true })
                    }
                }
            }
        }
        catch (err) {
            if (err.response.status === 500) {
                setError(err?.response?.data?.error)
                console.log(err?.response?.data)
            }
        }
    }

    const handleNameChange = (e) => {
        setName(e.target.value);
        setErrors({ ...errors, name: '' });
    };

    const handleEmailOrPhoneChange = (e) => {
        setUser(e.target.value);
        setErrors({ ...errors, emailOrPhone: '' });
    };

    const handlePasswordChange = (e) => {
        setPassword(e.target.value);
        setErrors({ ...errors, password: '' });
    };

    const toggleModal = () => {
        setIsModalVisible(!isModalVisible);
    };

    useEffect(() => {
        let countdown;
        if (isWaiting && timer > 0) {
            countdown = setInterval(() => {
                setTimer((prev) => prev - 1);
            }, 1000);
        } else if (timer === 0 && isWaiting) {
            setIsWaiting(false);
        }
        return () => clearInterval(countdown);
    }, [timer, isWaiting]);


    const maskFirstChars = (str, numChars) => {
        if (!str || str.length <= numChars) return '*'.repeat(str.length);
        return '*'.repeat(numChars) + str.slice(numChars);
    };


    return (
        <div className="SignUp-page">
            <div>
                <div className="mb-2 lock-img" style={{ alignSelf: "flex-start" }}>
                    <img src={awlogo} alt="AW Logo" />
                </div>
                <div className="Sigup-heading">
                    <p>SignUp</p>
                    <p>Create an account</p>
                </div>

                <div className="flex flex-col gap-5">

                    <p style={{
                        color: "#75623F",
                        fontFamily: "'Poppins', sans-serif",
                        fontWeight: 500,
                        width: "max-content",
                        alignSelf: "flex-end",
                        cursor: "pointer",
                        borderBottom: "1px solid #75623F"

                    }}
                        onClick={() => {
                            if (SignupMethod === 'Email') {
                                setSignUpMethod('Mobile');
                            } else {
                                setSignUpMethod('Email');
                            }
                        }}>
                        {SignupMethod === 'Email' ? 'Use Mobile Number' : 'Use Mail ID'}</p>

                    {/* <TextField
                        value={name}
                        onChange={handleNameChange}
                        placeholder="Enter your name"
                        error={!!errors.name}
                        helperText={errors.name}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <AccountCircle />
                                </InputAdornment>
                            ),
                        }}
                    /> */}
                    <TextField
                        value={user}
                        onChange={handleEmailOrPhoneChange}
                        placeholder={SignupMethod === 'Email' ? 'Enter mail id' : 'Enter Mobile Number'}
                        error={!!errors.emailOrPhone}
                        helperText={errors.emailOrPhone}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    {SignupMethod === 'Email' ? <Email /> : <SmartphoneIcon />}
                                </InputAdornment>
                            ),
                        }}
                        sx={{
                            '& .MuiOutlinedInput-root': {
                                '&.Mui-focused fieldset': {
                                    borderColor: '#DA6E0B',
                                },
                            },
                        }}
                    />

                    <TextField
                        value={password}
                        onChange={handlePasswordChange}
                        placeholder="Create Password"
                        type={showPassword ? 'text' : 'password'}
                        error={!!errors.password}
                        helperText={errors.password}
                        sx={{
                            '& .MuiOutlinedInput-root': {
                                '&.Mui-focused fieldset': {
                                    borderColor: '#DA6E0B',
                                },
                            },
                        }}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <Lock />
                                </InputAdornment>
                            ),
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton
                                        aria-label="toggle password visibility"
                                        onClick={handleClickShowPassword}
                                    >
                                        {showPassword ? <Visibility /> : <VisibilityOff />}
                                    </IconButton>
                                </InputAdornment>
                            ),
                        }}
                    />

                    <TextField
                        value={cpassword}
                        onChange={(e) => { setcPassword(e.target.value) }}
                        placeholder="Confirm Password"
                        type={showCPassword ? 'text' : 'password'}
                        error={!!errors.cpassword}
                        helperText={errors.cpassword}
                        sx={{
                            '& .MuiOutlinedInput-root': {
                                '&.Mui-focused fieldset': {
                                    borderColor: '#DA6E0B',
                                },
                            },
                        }}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <Lock />
                                </InputAdornment>
                            ),
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton
                                        aria-label="toggle password visibility"
                                        onClick={handleClickShowCPassword}
                                    >
                                        {showCPassword ? <Visibility /> : <VisibilityOff />}
                                    </IconButton>
                                </InputAdornment>
                            ),
                        }}
                    />

                </div>

                <div className="flex flex-col gap-5 Welcome-action-btn">
                    <div>
                        <Button
                            style={{
                                width: '100%',
                                textTransform: 'none',
                                borderRadius: '0',
                                backgroundColor: '#DA6E0B',
                                color: 'white',
                                border: 'none',
                                boxSizing: 'border-box',
                                borderRadius: '5px',
                                fontFamily: "'Poppins', sans-serif",
                                fontWeight: 500,
                                padding: '10px'
                            }}

                            onClick={handleSubmit}
                        >

                            {loading ? <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                <CircularProgress style={{
                                    color: "white"
                                }} size="30px" />
                            </div> : "Sign up"}

                        </Button>
                    </div>

                    <div className="Signuptermsandcondition">
                        <p className="flex flex-row justify-center items-center gap-5 text-center">
                            By signing up you accept the<br />
                            <span style={{
                                fontWeight: '500',
                                color: '#75623F',
                                borderBottom: '1px solid #75623F',
                                fontSize: "Bold",
                                cursor: 'pointer'
                            }}><a href='/termsandconditionaiwell.html'>T & C</a></span>
                        </p>
                    </div>
                    <div className="flex flex-row justify-center items-center gap-5 Signuptermsandcondition">
                        <p style={{ color: '#75623F' }}>Are you an existing User?</p>
                        <p
                            style={{
                                fontWeight: '500',
                                color: '#75623F',
                                borderBottom: '1px solid #75623F',
                                cursor: 'pointer'
                            }}
                            onClick={() => {
                                navigate('/Login', {
                                    state: { from: location.state?.from },
                                    replace: true
                                });
                            }}
                        >
                            Login
                        </p>
                    </div>
                </div>

                {isModalVisible && (
                    <div className="modal-overlay" onClick={toggleModal}>
                        <div className="bottom-sheet" onClick={(e) => e.stopPropagation()}>
                            <div className="handle"></div>
                            <div className="bottom-sheet-content">
                                <h2>Authentication Code</h2>
                                <p>{SignupMethod === "Email" ?
                                    `Enter the 6 digit code send to your respective mail id ends with ${maskFirstChars(user, 6)}` :
                                    `Enter the 6 digit code send to your respective mobile number ${maskFirstChars(user, 6)}`}</p>
                                <div className='login-otp-text-input'>

                                    <div className='login-otp-text-input-div'>
                                        <OTPInput
                                            value={otp}
                                            onChange={setOtp}
                                            numInputs={6}
                                            inputStyle={{
                                                border: "1px solid transparent",
                                                borderRadius: "8px",
                                                width: "54px",
                                                height: "54px",
                                                fontSize: "16px",
                                                color: "#000",
                                                fontWeight: "500",
                                                outline: "1px solid silver",
                                                caretColor: "blue"
                                            }}

                                            renderSeparator={<span style={{ visibility: "hidden" }}>--</span>}
                                            renderInput={(props) => <input {...props} inputmode="numeric" />}
                                        />
                                    </div>

                                    <div className='login-otp-text-input-div'>

                                        <p style={isWaiting ? { visibility: 'visible' } : { visibility: "hidden" }}>{timer} s</p>

                                        {
                                            <p onClick={handleResend} style={!isWaiting ? { visibility: 'visible' } : { visibility: "hidden" }}>Resend Code</p>
                                        }

                                    </div>

                                    {error && <p style={{ color: 'red' }}>{error}</p>}

                                    <div className='login-otp-text-input-div'>
                                        <Button
                                            style={{
                                                width: '100%',
                                                textTransform: 'none',
                                                borderRadius: '0',
                                                backgroundColor: '#DA6E0B',
                                                color: 'white',
                                                border: 'none',
                                                boxSizing: 'border-box',
                                                borderRadius: '5px',
                                                fontFamily: "'Poppins', sans-serif",
                                                fontWeight: 500,
                                                padding: '10px'
                                            }}
                                            onClick={handleVerify}
                                        >
                                            Verify Account
                                        </Button>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                )}

            </div>
        </div>
    );
}

export default SignUp;
